/** @module */

/**
 * @enum {string}
 * @includevals
 */
export const renderingTypes = {
    pano: 'pano',
    flat: 'flat',
};